export default __webpack_public_path__ + "static/media/doctor3.7cd4ae66.jpg";